import { useEffect } from 'react';
import { useLocalMediaActions } from '..';

export function useToggleAudioWithSpaceKey(): void {
  const { toggleAudio } = useLocalMediaActions();
  useEffect(() => {
    const muteOnSpaceKeyPress = (e: KeyboardEvent) => {
      if (
        e.key === ' ' &&
        (document.activeElement === document.body ||
          document.activeElement?.nodeName === 'VIDEO')
      ) {
        void toggleAudio();
      }
    };
    document.addEventListener('keyup', muteOnSpaceKeyPress);
    return () => document.removeEventListener('keyup', muteOnSpaceKeyPress);
  }, [toggleAudio]);
}
